import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { saveGmailOAuthTokens } from '../Modules/Settings/Policies/PoliciesAPI';

const OAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state'); // agencyId

    if (code) {
      if (window.opener) {
        // WEBSITE LOGIC: Keep existing working behavior
        window.opener.postMessage({ code, agencyId: state }, window.location.origin);
        window.close();
      } else {
        // MOBILE/WEBVIEW LOGIC: Handle API call and redirect directly
        const handleMobileAuth = async () => {
          try {
            await saveGmailOAuthTokens(code);
            navigate('/settings', { replace: true });
          } catch (error) {
            navigate('/settings', { replace: true });
          }
        };
        handleMobileAuth();
      }
    }

  }, [location]);

  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>Linking your Gmail account...</h2>
      <p>This window will close automatically.</p>
    </div>
  );
};

export default OAuthCallback;